const nameFilter = {
  namespaced: true,
  state: {
    data: ""
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    setData(context, value) {
      context.commit("SET_DATA", value);
    }
  },
  getters: {
    data: state => {
      return state.data;
    },
    toParams: state => {
      if (state.data.length === 0) {
        return;
      }
      return [
        {column: "fullName", value: state.data},
      ];
    }
  }
};

export default nameFilter;
